import { inputAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    borderColor: "gray.300",
    bg: "white",
    _focus: {
      borderColor: "purple.500",
    },
    rounded: "xl",
    _dark: {
      borderColor: "gray.600",
      bg: "black.700",
    },
  },
});

export const Input = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {
    size: "lg",
  },
});
